<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ !industry.id ? 'Create' : 'Edit' }} Industry</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit()">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Industry</mat-label>
      <input
        matInput
        placeholder="Industry"
        [(ngModel)]="industry.name"
        name="name"
        type="text"
        required
        #name />
      <mat-error *ngIf="!name.valid">Please enter a Industry.</mat-error>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">
    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit"
      id="save">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      type="button"
      color="warn"
      mat-icon-button
      [disabled]="!industry.id"
      class="dialog-remove-button my-2 ml-auto mr-1"
      (click)="onDelete()">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-dialog-actions>
</form>
